export default {
  CANCEL: 'CANCEL',
  CLOSE: 'CLOSE',
  ERROR: 'ERROR',
};
